export const getLang = () => document.documentElement.dataset.jsLang

export const getLangPrefix = () => document.documentElement.getAttribute('prefix')
